import { styled } from '@mui/material';

export const StyledSearch = styled('div')(({ theme }) => ({
  position: 'relative',

  '& > svg:first-of-type': {
    position: 'absolute',
    left: '0.75rem',
    top: '0.75rem',
    zIndex: 10,
  },

  '& .MuiInputBase-root': {
    borderRadius: '20px',
    border: `1px solid ${theme.palette.common.white}`,
    // TODO add color to library
    backgroundColor: '#F2F2F2',
  },

  '.MuiInputAdornment-root': {
    marginBottom: '0.2rem',

    '&:hover': {
      cursor: 'pointer',
    },
  },

  '.Mui-focused': {
    border: `1px solid ${theme.palette.primary.main}`,
  },

  '& .MuiTextField-root': {
    width: '100%',
  },

  '& .MuiInputBase-input': {
    paddingLeft: '2.25rem',
  },

  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',

    '&:focus': {
      border: 'none',
    },
  },
}));
